import AirLines from "../data/airlines.json";

const getAirLineName = (code: string): string => {
  const airLine = AirLines.find((airLine) => airLine.iata === code);
  if (airLine !== null && airLine !== undefined) {
    return airLine.name;
  }
  return "N/A";
};

export { getAirLineName };
